module.exports = __webpack_public_path__ + "static/media/Observation icon.d3e95894.png";